import { Injectable } from '@angular/core';

@Injectable()
export abstract class TranslationService {
  abstract getActiveLanguage(): string;
}
